/*@flow*/
import history from 'lib/history';
import { useEffect, useState } from 'react';

/**
 * useHistory is a reactive hook around browser history change events.
 *
 * @export
 * @return {*}  {{ query: ?{ [key: string]: string } }}
 */
export default function useHistory(): { query: ?{ [key: string]: string } } {
  const [loc, setLocation] = useState({});
  useEffect(() => {
    let isLoaded = true;
    const unlistener = history.listen((loc2) => {
      setLocation(loc2);
    });

    setTimeout(() => {
      isLoaded && setLocation(history.getCurrentLocation());
    }, 100);

    return () => {
      isLoaded = false;
      unlistener();
    };
  }, []);
  return loc;
}
